import { LRUCache } from "lru-cache";

export const person_cacheName = "personCache";
export const sijainti_cacheName = "sijaintiCache";
export const keikkaBetoni_cacheName = "betoniInfoCache"; // 0
export const vehicle_cacheName = "vehicleCache";
export const vehicleDrivers_cacheName = "vehicleDriversCache";
export const asiakasAuth_cacheName = "asiakasAuthCache";
export const asiakas_cacheName = "asiakasCache";
export const asiakasPerson_cacheName = "asiakasPersonCache";
export const tyomaa_cacheName = "tyomaaCache";
export const asiakasPersonSetting_cacheName = "asiakasPersonSettingCache";
export const tuote_cacheName = "tuoteCache";
export const general_cacheName = "generalCache"; // 0
export const helps_cacheName = "helpsCache";
export const keikka_cacheName = "keikkaCache";
export const grid_barColorsName = "gridBarColors";
export const grid_dayVehicle_cacheName = "grid_dayVehicle";
export const betoni_cacheName = "betoniCache";
export const stat_cacheName = "statCache";
export const dailyMessage_cacheName = "dailyMessageCache";
export const email_cacheName = "emailCache";

// Configure default options for all caches
const defaultOptions = {
  // Maximum size of each cache (number of items)
  max: 500,

  // TTL in milliseconds (5 minutes default)
  ttl: 1000 * 60 * 5,

  // Return stale items before removing them
  allowStale: false,

  // Update TTL when items are accessed
  updateAgeOnGet: true,

  // Optional: Add size calculation if needed
  // sizeCalculation: (value, key) => 1,
};

// Initialize cache container and tracking
const caches = new Map();
const cacheStats = new Map();

// Helper to get or create cache instance
function getCache(cacheName) {
  if (!caches.has(cacheName)) {
    caches.set(cacheName, new LRUCache(defaultOptions));
    cacheStats.set(cacheName, { hits: 0, misses: 0 });
  }
  return caches.get(cacheName);
}

export function cache_read(cacheName, fullUrl) {
  const cache = getCache(cacheName);
  const stats = cacheStats.get(cacheName) || { hits: 0, misses: 0 };
  const value = cache.get(fullUrl);

  // Track hits and misses
  if (value !== undefined) {
    stats.hits++;
  } else {
    stats.misses++;
  }

  return value ?? null;
}

export async function cache_write(cacheName, fullUrl, data, expiresMinutes = 5) {
  const cache = getCache(cacheName);
  let ttl = expiresMinutes === 0 ? Infinity : expiresMinutes * 60 * 1000;
  cache.set(fullUrl, data, { ttl });
}

export function cache_clear_ALL() {
  caches.forEach((cache) => cache.clear());
  // Clear stats as well
  cacheStats.clear();
}

export function cache_clear(cacheName) {
  const cache = caches.get(cacheName);
  if (cache) {
    cache.clear();
    // Clear stats as well
    cacheStats.set(cacheName, { hits: 0, misses: 0 });
  }
}

export function cache_delete(cacheName, fullUrl) {
  const cache = caches.get(cacheName);
  if (cache) cache.del(fullUrl);
}

// Optional: Get cache statistics
export function getCacheStats(cacheName) {
  const cache = caches.get(cacheName);
  const stats = cacheStats.get(cacheName);
  if (!cache) return null;

  return {
    size: cache.size,
    maxSize: cache.max,
    hits: stats.hits,
    misses: stats.misses,
    keySize: cache.keys().length,
  };
}

// Get total size and stats for all caches combined
export function getTotalCacheSize() {
  let totalItems = 0;
  let totalHits = 0;
  let totalMisses = 0;
  const cacheDetails = [];

  caches.forEach((cache, cacheName) => {
    const stats = cacheStats.get(cacheName);
    totalItems += cache?.size || 0;
    totalHits += stats?.hits || 0;
    totalMisses += stats?.misses || 0;

    cacheDetails.push({
      name: cacheName,
      size: cache.size,
      maxSize: cache.max,
      hits: stats?.hits || 0,
      misses: stats?.misses || 0,
    });
  });

  return {
    totalItems,
    totalCaches: caches.size,
    totalHits,
    totalMisses,
    cacheDetails,
  };
}
